module.exports = __webpack_public_path__ + "img/suzhou.8dd4dd9a.png";